import { Component, Input, OnInit } from '@angular/core';


@Component({
  selector: 'molla-area-agente',
  templateUrl: './area-agente.component.html',
  styleUrls: ['./area-agente.component.scss']
})
export class AreaAgenteComponent implements OnInit {

  @Input() idUtente!: number;
  @Input() COD_AGE: string = "";

  constructor() { }

  ngOnInit(): void {

  }

}
